import get from "lodash/get";

export const isLoadingUsers = id => state => get( state.config.users.teamConfig.users[ id ], "loading" );
export const getUsers = id => state => get( state.config.users.teamConfig.users[ id ], "data", [] );